import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from './Modal';
import './WhiteListNotStartedModal.css';

export interface WhiteListNotStartedModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const WhiteListNotStartedModal: React.FC<WhiteListNotStartedModalProps> = ({
  isOpen,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleViewProgress = () => {
    onClose();
    navigate('/white-list');
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="White List ещё не стартовал.">
      <div className="whitelist-not-started-modal-content">
        <p className="whitelist-not-started-modal-description">
          Приобрести NFT можно будет после запуска White List. Он стартует, когда наберётся 1000
          участников. До старта вы можете ознакомиться с текущим прогрессом.
        </p>
        <button className="button--primary button--full" onClick={handleViewProgress}>
          Посмотреть прогресс
        </button>
        <button className="button--secondary button--full" onClick={onClose}>
          Отмена
        </button>
      </div>
    </Modal>
  );
};
